<template>
  <div class="container-fluid mt-2">
    <h2>Auftr&auml;ge</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" @keyup="updateSearch()" id="search" v-model="search" type="text"/>
      </div>
    </div>
    <b-table @row-clicked="openOrder" @sort-changed="updateSort" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(deliverDate)="data">
        {{ data.item.deliverdate }}
      </template>
      <template v-slot:cell(sum)="data">
        {{ Number(data.item.netto).toFixed(2) }}
      </template>
      <template v-slot:cell(status)="data">
        {{ calcStatus(data.item) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import orders from '@/modules/orders.js'

export default {
  name: 'OrderList',
  props:['customer'],
  data() {
    return {
      search: "",
      rows: [],
      fields: [
        {label:"Auftrags-Nr.",key:"map_id",      sortable: true },
        {label:"Kunde-Nr",    key:"customerid",  sortable: true, sortKey:"customer_id" },
        {label:"Kunde",       key:"customer.title"},
        {label:"Erstellt",    key:"created",     sortable: true},
        {label:"Lieferdatum", key:"deliverDate", sortable: true},
        {label:"Summe",       key:"sum"},
        {label:"Vertreter",   key:"handid"},
        {label:"Status",      key:"status"}
      ]
    }
  },
  mounted: function() {
    if (this.customer)
      orders.viewparams.cid = this.customer;
    else
      orders.viewparams.cid = '';
    this.fetchData();
  },
  methods: {
    updateSort: function(data) {
      console.log(data);
      var sort = data.sortBy;
      if (sort == 'customerid') sort = 'customerId';
      if (sort == 'deliverdate') sort = 'deliverDate';
      orders.viewparams.sdir = (data.sortDesc ? 'desc' : 'asc');
      orders.viewparams.sort = sort;
      this.fetchData();
    },
    fetchData: function() {
      var self = this;
      orders.list(function(data) {
        self.rows = data.rows;
      })
    },
    openOrder(row) {
      router.push({ name:'OrderView',params: {orderid: row.id }});
    },
    calcStatus: function(row) {
      if (row.status == 2) return 'Übermittelt'; else if (row.status == 0) return 'Neu'; else return 'Fehler';
    },
    updateSearch: function() {
      orders.viewparams.search = this.search;
      this.fetchData();
    },
    prevPage: function() {
      if (orders.viewparams.page > 1) {
        orders.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        orders.viewparams.page++;
        this.fetchData();
      }
    }
  }
}
</script>
